import { inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TvLoginStore } from '../../pages/app/services/app.store';
import { ClientSSO } from '../entities/client-sso';
import { LoginResponse } from '../entities/login-response';

@Injectable()
export class StoreService {
  readonly tvLoginStore = inject(TvLoginStore);

  client: ClientSSO = null;
  goTo: Function = null;
  loginResponse: LoginResponse = null;

  termsParams: Record<string, unknown> | null = null;

  private backgroundImageStyle = new BehaviorSubject<string | boolean>(false);
  private footerLogoStyle = new BehaviorSubject<string | boolean>(false);

  resetAllClientRelatedInfo() {
    this.resetClient();
    this.resetLoginResponse();
    this.resetFooterLogoStyle();
    this.resetBackgroundImageStyle();
    this.tvLoginStore.setCustomCss(false);
  }

  resetClient() {
    this.client = null;
  }

  resetLoginResponse() {
    this.loginResponse = null;
  }

  resetFooterLogoStyle() {
    this.footerLogoStyle.next('default');
  }

  resetBackgroundImageStyle() {
    this.backgroundImageStyle.next('default');
  }

  isClientDefined(): boolean {
    return !!(this.client && this.client.alias);
  }

  setFooterLogoStyle(): void {
    if (
      this.isClientDefined() &&
      this.client.isCustomizationDefined() &&
      this.client.customization.isFooterLogoDefined()
    ) {
      this.footerLogoStyle.next(this.client.customization.footerLogo.id);
    } else {
      this.footerLogoStyle.next(false);
    }
  }

  setBackgroundImageStyle(): void {
    if (
      this.isClientDefined() &&
      this.client.isCustomizationDefined() &&
      this.client.customization.isBackgroundImageDefined()
    ) {
      this.backgroundImageStyle.next(this.client.customization.backgroundPicture.id);
    } else {
      this.backgroundImageStyle.next(false);
    }
  }

  setCustomCSS(): void {
    const isCustom =
      this.isClientDefined() && this.client.isCustomizationDefined() && this.client.customization.isCustomCssDefined();

    this.tvLoginStore.setCustomCss(isCustom);
  }

  getLoginAlias(): string {
    if (this.client?.alias) {
      return this.client.alias;
    }

    if (this.loginResponse?.clientAlias) {
      return this.loginResponse.clientAlias;
    }

    return this.tvLoginStore.getUrlParameterClientAlias();
  }

  isUserDefined(): boolean {
    return !!(this.loginResponse && this.loginResponse.preferences);
  }

  getUserPreferredLanguageId(): number | null {
    return this.isUserDefined() ? this.loginResponse.preferences.languageId : null;
  }
}
